export default "__VITE_PUBLIC_ASSET__34dc53e9__"